import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../token.service';
import { MainService } from './main.service';

@Injectable({
  providedIn: 'root'
})
export class UserAddService {

  httpUrl;
  constructor(private http: HttpClient, private main: MainService, private token:TokenService) {
    this.httpUrl = this.main.httpUrl + '/usermanagement';
  }
  async getUsersInfo(obj :any) {

    const resp = await this.http.get(this.httpUrl + '/getUsersInfo' + obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getAllUsersInfo(obj :any) {

    const resp = await this.http.get(this.httpUrl + '/getAllUsersInfo' + obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async addUsers(obj :any) {

    const resp = await this.http.post(this.httpUrl + '/addUser', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateUsers(obj :any) {

    const resp = await this.http.put(this.httpUrl + '/updateAssignedProducts', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteUsers(obj :any) {

    const resp = await this.http.delete(this.httpUrl + '/deleteUser'+ obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }


}
